import React, { useState, useContext, useEffect } from "react";
import { Drawer } from "antd";
import { NavLink } from "react-router-dom";
import menu from "./../../home/assets/menu.png";
import drwerBtnLine from "./../../home/assets/drawer-line-big@2x.png";
import { vocesTotalesByTarget } from "../api";
import { setDrawerVisible } from "../../giveVoiceComp/Tabs/api";
import { vozavosContext } from "../../vozavosContext";
import { animateScroll as scroll } from 'react-scroll';
import { getUserPhoto } from "../../../assets/api";
import "./drawer.css";

const scrollType = {
  duration: 10,
  smooth: true,
};

// asignar el valor de las unidades en milisegundos
const MSEC_POR_SEGUNDO = 1000;
const MSEC_POR_MINUTO = MSEC_POR_SEGUNDO * 60;
const MSEC_POR_HORA = MSEC_POR_MINUTO * 60;
const MSEC_POR_DIA = MSEC_POR_HORA * 24;

// De la unidad más grande a la más pequeña: se muestra la primera cuyo valor sea mayor que cero.
const UNIDADES_DE_TIEMPO = [
  { msec: MSEC_POR_DIA, singular: ' día', plural: ' días' },
  { msec: MSEC_POR_HORA, singular: ' hora', plural: ' horas' },
  { msec: MSEC_POR_MINUTO, singular: ' minuto', plural: ' minutos' },
  { msec: MSEC_POR_SEGUNDO, singular: ' segundo', plural: ' segundos' },
];

const TEXTO_VOZ_PEDIDA = 'quiere recibir tu Voz!';
const TEXTO_VOZ_DADA = 'te ha dado una Voz!';
const TIPO_VOZ_PEDIDA = 'pedir';
const TIPO_VOZ_DADA = 'dar';

// Devuelve, por ejemplo, "Hace 3 horas". Resta de forma sucesiva lo ya contado en cada unidad,
// igual que el cálculo original, para conservar el resultado también con fechas futuras.
export const calcularTiempoTranscurrido = (fecha) => {
  let restante = new Date().getTime() - new Date(fecha).getTime();

  for (const { msec, singular, plural } of UNIDADES_DE_TIEMPO) {
    const cantidad = Math.floor(restante / msec);
    if (cantidad > 0) {
      return `Hace ${cantidad + (cantidad === 1 ? singular : plural)}`;
    }
    restante = restante - (cantidad * msec);
  }
};

// La otra persona de la voz: si yo soy el origen es el destinatario, y en caso contrario es el origen.
const obtenerContraparte = (item, correo) => (
  item.origen === correo
    ? { correo: item.target, nombre: item.targetName }
    : { correo: item.origen, nombre: item.origenName }
);

const esVozPedida = (item, correo) => item.target === correo && item.competenciaSolicitada.length > 0;

const construirVoz = (item, correo, urlPhoto) => {
  const vozPedida = esVozPedida(item, correo);
  return {
    nameVoz: obtenerContraparte(item, correo).nombre,
    createdAt: item.createdAt,
    id: item.id,
    url: urlPhoto,
    vozDesc: vozPedida ? TEXTO_VOZ_PEDIDA : TEXTO_VOZ_DADA,
    tipoVoz: vozPedida ? TIPO_VOZ_PEDIDA : TIPO_VOZ_DADA,
    time: calcularTiempoTranscurrido(item.createdAt)
  };
};

// Las fotos se piden una por una, en orden, como en el código original.
const construirListaVoces = async (items, correo, client) => {
  const vocesList = [];
  for (const item of items) {
    const contraparte = obtenerContraparte(item, correo);
    const urlPhoto = await getUserPhoto(contraparte.correo, contraparte.nombre, client);
    vocesList.push(construirVoz(item, correo, urlPhoto));
  }
  return vocesList;
};

// Más recientes primero.
const compararPorFechaDescendente = (a, b) => {
  if (a.createdAt < b.createdAt) return 1;
  if (a.createdAt > b.createdAt) return -1;
  return 0;
};

const DrawerComp = (props) => {
  const {
    state: { client, userName, mail, renderGiveVoice, renderMyVoices, renderMyVoicesReceived }, //mail
    actions: { setRenderGiveVoice, setRenderMyVoices, setRenderMyVoicesReceived },
  } = useContext(vozavosContext);
  const { setShowDotIcon } = props;
  const [visible, setVisible] = useState(false);
  const [listVoces, setListVoces] = useState([]);
  const [showLid, setShowllid] = useState(false);

  useEffect(() => {
    async function loadVocesSinleer() {
      const vocesList = await generateVocesList();
      setListVoces(vocesList);
    }
    loadVocesSinleer();
  }, [mail])

  const showDrawer = () => {
    setVisible(true);
    setShowllid(true);
  };
  const onClose = () => {
    setVisible(false);
    setShowllid(false);
  };

  const generateVocesList = async () => {
    const filterTarget = {
      target: mail.toLowerCase(),
      filter: {
        "drawerVisible": { "eq": true },
        "competenciaSolicitada": { "ne": null }
      }
    };

    if (mail.length === 0) return;

    const vc = await vocesTotalesByTarget(filterTarget, userName, mail);
    const vocesList = await construirListaVoces(vc, mail.toLowerCase(), client);
    if (vocesList.length > 0) setShowDotIcon(true);
    return [...vocesList].sort(compararPorFechaDescendente);
  }

  const misVocesTab = async (id) => {
    setRenderMyVoices(!renderMyVoices);
    scroll.scrollToTop(scrollType);
    if (!renderMyVoicesReceived)
      setRenderMyVoicesReceived(true);
    await setDrawerVisible(id, userName, mail);
  };

  const renderTableData = () => {
    if (typeof listVoces !== 'undefined') {
      return listVoces.map((voz, index) => {
        const { id, nameVoz, time, url, vozDesc, tipoVoz } = voz
        return (
          <>
            <tr id={id.toString()} key={index}>
              <td className="filaImpar" rowSpan="2">
                <div className="contentImg">
                  <img id='photoTarget' mode='fit' src={url} alt="" />
                </div>
              </td>
              <td className="filaImparcontent">
                {tipoVoz === 'pedir' ?
                  <NavLink to={`/givevoice/${id}`} onClick={() => { setRenderGiveVoice(!renderGiveVoice); scroll.scrollToTop(scrollType); }}>
                    <div className="content">¡{nameVoz} {vozDesc}</div>
                  </NavLink>
                  :
                  <NavLink to={`/voice/${id}`} onClick={() => { misVocesTab(id) }}>
                    <div className="content">¡{nameVoz} {vozDesc}</div>
                  </NavLink>
                }
              </td>
            </tr>
            <tr>
              <td className="filaImpar">
                <span className="timeduration">{time}</span>
              </td>
            </tr>
          </>
        )
      })
    }
  }

  return (
    <>
      < div className="sideDrawer" >
        <div
          className={showLid ? "drwerDivBtnMove " : "drwerDivBtn"}
          onClick={showDrawer} data-testid="showDrawer"
        >
          <img className="drwerBtnLineStyle" src={drwerBtnLine} alt="" />
          <img className="drwerBtnLineStyle1" src={drwerBtnLine} alt="" />
        </div>
        <div className="drwerDivBtn1" onClick={showDrawer}>
          <img className="" src={menu} alt="" />
        </div>

        <div className="opnnotific" data-testid="opnnotific" onClick={showDrawer}></div>
        <Drawer
          title="Notificaciones"
          placement="right"
          closable={false}
          onClose={onClose}
          visible={visible}
          mask={true}
        >
          <table className="cssTable" data-testid="cssTable" border="0px">
            <tbody >
              {renderTableData()}
            </tbody>
          </table>
        </Drawer>
      </div >
    </>
  );
};
export default DrawerComp;
